import { CopyQRCodeId } from "../Constants/CopyQRCode";

export const copyQRCodeIdData = (copyData) => {
    return {
        type: CopyQRCodeId.SET_CopyQRCodeIdData,
        payload: copyData
    };
};